import { useMemo } from 'react'

import { Link, T } from 'govwell-ui'
import { EntityForViewFragment } from 'types/graphql'

import { routes } from '@redwoodjs/router'

type Props = {
  entity?: EntityForViewFragment | null
  displayName?: string | null
}

export const EntityDisplay = ({ entity, displayName }: Props) => {
  const content = useMemo(() => {
    if (entity) {
      const url = entityUrl(entity)
      return url ? (
        <Link internalRoute={url}>{displayName ?? entity.name}</Link>
      ) : (
        (displayName ?? entity.name)
      )
    } else if (displayName) {
      return displayName
    }
    return '-'
  }, [entity, displayName])

  return <T.Body>{content}</T.Body>
}

export const entityUrl = (entity: EntityForViewFragment): string | null => {
  if (entity.layer?.type === 'Address') {
    return routes.entityAddress({ addressUuid: entity.uuid })
  }
  if (entity.layer?.type === 'Parcel') {
    return routes.entityParcel({ parcelUuid: entity.uuid })
  }
  return null
}
